export { default as fraudReportDuck } from './fraudReportDuck.js';
export { default as vdpActiveEmailListingDuck } from './vdpActiveEmailListingDuck.js';
export { default as vdpActiveInteractionDuck } from './vdpActiveInteractionDuck.js';
export { default as vdpAdsDuck } from './vdpAdsDuck.js';
export { default as vdpAvailableOffersDuck } from './vdpAvailableOffersDuck.js';
export { default as vdpContentDuck } from './vdpContentDuck.js';
export { default as vdpDRDuck } from './vdpDRDuck.js';
export { default as vdpModelInfoDuck } from './vdpModelInfoDuck.js';
export { default as vdpRatingReviewDuck } from './vdpRatingReviewDuck.js';
export { default as vdpResultsDuck } from './vdpResultsDuck.js';
export { default as vdpReviewPaginationDuck } from './vdpReviewPaginationDuck.js';
export { default as vdpSimilarListingsDuck } from './vdpSimilarListingsDuck.js';
export { default as vdpSimilarDealerListingsDuck } from './vdpSimilarDealerListingsDuck.js';
export { default as vdpVideoDuck } from './vdpVideoDuck.js';
export { default as vdpExtendedHomeDeliveryDuck } from './vdpExtendedHomeDeliveryDuck.js';
export { default as vdpDealerDiffDuck } from './vdpDealerDiffDuck.js';
